import * as React from 'react';
import noop from 'lodash/noop';
import { HotKeys } from 'react-hotkeys';
import { MdAdd } from 'react-icons/md';
import { keyCodeTypes } from 'ui/common/key-code-types';
import { AddButton } from 'ui/common/button/add-button';
import { DialogExpander } from 'ui/common/dialog-expander/dialog-expander';
import { ButtonPrimary } from 'ui/common/button/button-primary';
import { MeatballMenu } from 'ui';
import { CloseOnBlur } from 'ui/common/close-on-blur';
import { ExtraFooterButton } from 'ui/common/select/types';
import { OnClickOutside } from 'ui/common/on-click-outside';
import styles from './options-panel-dialog.scss';

interface OptionsPanelDialogComponentProps {
  removeAllText?: string;
  addButtonText: string;
  doneButtonText: string;
  onSubmit: () => void;
  removeAll?: () => void;
  extraFooterButton?: ExtraFooterButton;
  children?: React.ReactNode;
}

interface OptionsPanelDialogComponentState {
  showSelectDialog: boolean;
}

class OptionsPanelDialogComponent extends React.Component<OptionsPanelDialogComponentProps, OptionsPanelDialogComponentState> {
  private keyMap: any;
  private handlers: any;

  constructor(props: OptionsPanelDialogComponentProps) {
    super(props);
    this.state = { showSelectDialog: false };

    this.keyMap = {
      onEnter: [keyCodeTypes.Enter]
    };

    this.handlers = {
      onEnter: () => this.onSubmit
    };
  }

  private closeSelectDialog = () => {
    this.setState({ showSelectDialog: false });
  };

  private openSelectDialog = () => {
    this.setState({ showSelectDialog: true });
  };

  private onSubmit = () => {
    this.props.onSubmit();
    this.closeSelectDialog();
  };

  private renderSelectDialog = () => {
    const { doneButtonText, children, extraFooterButton } = this.props;

    return <div className={styles.dialogContainer}>
      <DialogExpander
        selectExpander={true}
        onClose={this.closeSelectDialog}
        hasFooter={false}>

        {this.state.showSelectDialog && <div className="row expanders-in-equal-cols">
          {React.Children.map(children, (child, i) => <div className="col-lg-12" key={i}>{child}</div>)}
        </div>}

        <div className="d-flex justify-content-end">
          {extraFooterButton && extraFooterButton(noop)}
          <ButtonPrimary onClick={this.onSubmit}>
            {doneButtonText}
          </ButtonPrimary>
        </div>
      </DialogExpander>
    </div>;
  };

  public render() {
    return <OnClickOutside onClickOutside={this.closeSelectDialog}>
      <CloseOnBlur onBlur={this.closeSelectDialog}>
        <HotKeys keyMap={this.keyMap} handlers={this.handlers}>
          <div className={styles.linkContainer}>
            <div className={`${styles.linkSelector} ${styles.addButton}`}>
              <AddButton icon={MdAdd} onClick={this.openSelectDialog} required={false}>
                {this.props.addButtonText}
              </AddButton>
              {this.state.showSelectDialog && this.renderSelectDialog()}
            </div>
            {this.props.removeAll && <MeatballMenu className={styles.meatball} closeAfterClick={true}>
              <li>
                <button type="button" className="dropdown-item" onClick={this.props.removeAll}>
                  {this.props.removeAllText}
                </button>
              </li>
            </MeatballMenu>}
          </div>
        </HotKeys>
      </CloseOnBlur>
    </OnClickOutside>;
  }
}

export const OptionsPanelDialog = OptionsPanelDialogComponent;
